import { createSelector } from 'reselect';
import { SearchExport } from '@fullstory/proto/fs/services/dex';
import { AppState } from '../../types';
import { SearchExportFilterType, makeSearchExportFilterKey } from './utils';
import { Timestamp } from '@fullstory/proto/google/protobuf';

export const getExportsById = (state: AppState) => state.searchExports.exportsById;
export const getExportIdsByFilter = (state: AppState) => state.searchExports.exportIdsByFilter;

export const getAllExports = createSelector(getExportsById, es => {
  if (!es) {
    return [];
  }
  const exportList = [...es.values()];
  exportList.sort((a, b) => Timestamp.toMillis(b.created) - Timestamp.toMillis(a.created));
  return exportList;
});

export const getFilteredExports = (f: SearchExportFilterType) =>
  createSelector(getAllExports, getExportIdsByFilter, (es, eids) => {
    const filterKey = makeSearchExportFilterKey(f);
    if (!es || !eids.get(filterKey)) return [];
    return es.filter(e => eids.get(filterKey)?.has(e.id));
  });

export const getFilteredPendingIds = (f: SearchExportFilterType) =>
  createSelector(getPendingExports, getExportIdsByFilter, (es, eids) => {
    const filterKey = makeSearchExportFilterKey(f);
    if (!es || !eids.get(filterKey)) return <string[]>[];
    return es.reduce((ids, exp) => {
      if (eids.get(filterKey)?.has(exp.id)) ids.push(exp.id);
      return ids;
    }, <string[]>[]);
  });

export const getPendingExports = createSelector(getAllExports, es =>
  es.filter(e => e.stateRollup == SearchExport.StateRollup.STATE_ROLLUP_PENDING),
);

export const getPendingExportIds = createSelector(getPendingExports, es => es.map(e => e.id));

export const getCompletedExports = createSelector(getAllExports, es =>
  es.filter(e => e.state == SearchExport.State.STATE_COMPLETED),
);
